import "./Contact.module.css";
import Navigering from "@/reusable_sections/Header";
import VisitUsInHalmstad from "./sections/VisitUsInHalmstad";
import TalkToASpecialistToday from "./sections/TalkToASpecialistToday";
import FeatureHighlight from "./sections/FeatureHighlight";
import SidfotInfo from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigering />
      <VisitUsInHalmstad />
      <TalkToASpecialistToday />
      <FeatureHighlight />
      <SidfotInfo />
    </div>;
}